import React from 'react';
import { useSiteBranding } from '../hooks/useSiteBranding';

/**
 * Floating "Custom Domain Preview" banner.
 *
 * Pinned to the bottom-right when the customer-facing site is being walked
 * with `?cdp=<client_id>` in the URL. Helps owners avoid mistaking a preview
 * for a verified production custom-domain visit.
 */
export default function CdpPreviewBanner() {
  const { isPreview, tenantName } = useSiteBranding();
  if (!isPreview) return null;
  return (
    <div
      className="fixed bottom-4 right-4 z-50 bg-[#E3000F] text-white text-xs font-bold px-3 py-2 shadow-lg flex items-center gap-2 max-w-xs"
      data-testid="cdp-preview-banner"
    >
      <span className="w-2 h-2 bg-white rounded-full animate-pulse" />
      <span>Preview mode · {tenantName}</span>
      <button
        onClick={() => {
          const url = new URL(window.location.href);
          url.searchParams.delete('cdp');
          window.location.href = url.toString();
        }}
        className="ml-2 text-white/70 hover:text-white text-[10px] underline"
        data-testid="cdp-preview-exit"
      >
        exit
      </button>
    </div>
  );
}
